import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchReviews } from './realTalkApi';
import './RealTalk.css';

// Compact "What students are saying about this college" section on the college detail
// page. Fetches ONLY approved reviews for the exact college name. Shows the average
// rating ONLY when there are at least 3 approved reviews. Never shows placeholders.
export default function CampusTruthCollegeSection({ collegeName }) {
  const [reviews, setReviews] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    if (!collegeName) { setLoading(false); return; }
    fetchReviews({ college: collegeName, page: 1, limit: 3 })
      .then((data) => { if (alive) { setReviews(data.reviews || []); setTotal(data.total || 0); } })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [collegeName]);

  if (loading) return null;

  const trackCta = (which) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'college_review_cta_clicked', { college_name: collegeName, cta: which });
    }
  };

  const avg = total >= 3 && reviews.length
    ? (reviews.reduce((a, r) => a + (r.overall_rating || 0), 0) / reviews.length).toFixed(1)
    : null;

  return (
    <section className="ct-college-section" data-testid="ct-college-section">
      <h3 className="ct-college-title">What students are saying about this college</h3>
      <p className="ct-college-hindi">कॉलेज का असली सच जानें</p>

      {total === 0 && (
        <div className="ct-empty-mini" data-testid="ct-college-empty">
          <strong>No Campus Truth reviews published yet.</strong>
          <span>Are you studying here? Help future students make a better decision.</span>
        </div>
      )}

      {avg && (
        <p style={{ fontSize: 13, color: '#0B2352', margin: '0 0 12px', fontWeight: 600 }}>
          Average rating: <span style={{ color: '#D4A24C' }}>{avg}/5</span> · based on {total} verified experience{total !== 1 ? 's' : ''}
        </p>
      )}

      {reviews.map((r) => (
        <article className="ct-mini-review" key={r.review_id} data-testid={`ct-mini-review-${r.review_id}`}>
          <div className="ct-mini-review-header">
            <span>{r.course} · {r.year}</span>
            {r.verified && <span className="rt-verified-badge">✓ Verified</span>}
            {r.voice_review_url && <span title="Voice review available">🎙️</span>}
          </div>
          {r.review_title && <p className="ct-mini-review-title">{r.review_title}</p>}
          <p className="ct-mini-review-excerpt">
            "{(r.written_review || '').substring(0, 160)}{(r.written_review || '').length > 160 ? '…' : ''}"
          </p>
        </article>
      ))}

      <div className="ct-college-ctas">
        <Link
          to={`/campus-truth?college=${encodeURIComponent(collegeName || '')}`}
          className="ct-college-cta ct-college-cta-primary"
          onClick={() => trackCta('read_all')}
          data-testid="ct-cta-read-all"
        >
          Read all student experiences →
        </Link>
        <Link
          to="/campus-truth#rt-submission-form"
          className="ct-college-cta ct-college-cta-secondary"
          onClick={() => trackCta('share')}
          data-testid="ct-cta-share"
        >
          Share your experience
        </Link>
      </div>
    </section>
  );
}
